module.exports = __webpack_public_path__ + "static/media/genres.56a180ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Inspiration/img/genres.png
// module id = 129
// module chunks = 0